import * as css from "./Panel.module.css"

function Panel({ label, title, description, children }) {
  return (
    <div className={css.panel}>
      <div className={css.label}>{label}</div>
      <div className={css.title}>{title}</div>
      <div className={css.description}>{description}</div>
      {children}
    </div>
  )
}

export default Panel
